import React, { Fragment, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import BlogSidebar from '../../components/BlogSidebar/BlogSidebar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import { getNews } from '../../api/backend';
import logo from '../../images/gattomioNero.png';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogTagPage = () => {
    const { tag } = useParams();
    const tagName = decodeURIComponent(tag);
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        getNews()
            .then(res => {
                const all = res.data || [];
                const filtered = all.filter(blog =>
                    (blog.tags || []).some(t => t.name === tagName)
                );
                setBlogs(filtered);
            })
            .catch(err => console.error('Errore caricamento news per tag:', err))
            .finally(() => setLoading(false));
    }, [tagName]);

    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={logo} />
            <PageTitle pageTitle={'Approfondimenti'} pagesub={<><Link to="/blog">News</Link> &gt; {tagName}</>} />
            <section className="wpo-blog-pg-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-12">
                            <div className="wpo-blog-content">
                                {loading ? (
                                    <p>Caricamento articoli...</p>
                                ) : blogs.length === 0 ? (
                                    <p>Nessun articolo trovato per il tag <strong>{tagName}</strong>.</p>
                                ) : (
                                    blogs.map((blog, i) => (
                                        <div className="post format-standard-image" key={blog.id || i}>
                                            <div className="image">
                                                {blog.image_url && (
                                                    <img src={blog.image_url} alt={blog.title} />
                                                )}
                                            </div>
                                            <div className="entry-meta">
                                                <ul>
                                                    <li><i className="fi flaticon-user"></i> By <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.author}</Link></li>
                                                    <li><i className="fi flaticon-calendar"></i> {blog.formatted_date}</li>
                                                </ul>
                                            </div>
                                            <div className="entry-details">
                                                <h3><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.title}</Link></h3>
                                                <p>{blog.description}</p>
                                                <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`} className="read-more">LEGGI TUTTO</Link>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                        <BlogSidebar />
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default BlogTagPage;
